/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Androidbeta_Title1Inputs */

const id_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bergabung dengan Beta`)
};

const ms_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sertai Beta`)
};

const da_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deltag i Beta`)
};

const de_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta beitreten`)
};

const en_us2_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the Beta`)
};

const es_es2_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete a la Beta`)
};

const es_mx2_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete a la Beta`)
};

const fil_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumali sa Beta`)
};

const fr_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoindre la bêta`)
};

const it_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partecipa alla Beta`)
};

const hu_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csatlakozz a Bétához`)
};

const nl_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deelnemen aan de Bèta`)
};

const no_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bli med i Beta`)
};

const pl_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dołącz do bety`)
};

const pt_br2_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the Beta`)
};

const pt_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juntar-se à Beta`)
};

const ro_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alătură-te Betai`)
};

const fi_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liity betaan`)
};

const sv_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå med i Betan`)
};

const vi_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tham gia Beta`)
};

const tr_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta'ya Katıl`)
};

const cs_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připojit se k beta`)
};

const bg_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Присъединете се към Beta`)
};

const ru_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Присоединиться к бета-тесту`)
};

const uk_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приєднатися до Beta`)
};

const ar_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انضم إلى الإصدار التجريبي`)
};

const hi_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बीटा में शामिल हों`)
};

const th_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าร่วมเบต้า`)
};

const ja_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベータ版に参加`)
};

const zh_cn2_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the Beta`)
};

const zh_hant1_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the Beta`)
};

const ko_forms_androidbeta_title1 = /** @type {(inputs: Forms_Androidbeta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the Beta`)
};

/**
* | output |
* | --- |
* | "Join the Beta" |
*
* @param {Forms_Androidbeta_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_androidbeta_title1 = /** @type {((inputs?: Forms_Androidbeta_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Androidbeta_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_androidbeta_title1(inputs)
	if (locale === "ms") return ms_forms_androidbeta_title1(inputs)
	if (locale === "da") return da_forms_androidbeta_title1(inputs)
	if (locale === "de") return de_forms_androidbeta_title1(inputs)
	if (locale === "en-US") return en_us2_forms_androidbeta_title1(inputs)
	if (locale === "es-ES") return es_es2_forms_androidbeta_title1(inputs)
	if (locale === "es-MX") return es_mx2_forms_androidbeta_title1(inputs)
	if (locale === "fil") return fil_forms_androidbeta_title1(inputs)
	if (locale === "fr") return fr_forms_androidbeta_title1(inputs)
	if (locale === "it") return it_forms_androidbeta_title1(inputs)
	if (locale === "hu") return hu_forms_androidbeta_title1(inputs)
	if (locale === "nl") return nl_forms_androidbeta_title1(inputs)
	if (locale === "no") return no_forms_androidbeta_title1(inputs)
	if (locale === "pl") return pl_forms_androidbeta_title1(inputs)
	if (locale === "pt-BR") return pt_br2_forms_androidbeta_title1(inputs)
	if (locale === "pt") return pt_forms_androidbeta_title1(inputs)
	if (locale === "ro") return ro_forms_androidbeta_title1(inputs)
	if (locale === "fi") return fi_forms_androidbeta_title1(inputs)
	if (locale === "sv") return sv_forms_androidbeta_title1(inputs)
	if (locale === "vi") return vi_forms_androidbeta_title1(inputs)
	if (locale === "tr") return tr_forms_androidbeta_title1(inputs)
	if (locale === "cs") return cs_forms_androidbeta_title1(inputs)
	if (locale === "bg") return bg_forms_androidbeta_title1(inputs)
	if (locale === "ru") return ru_forms_androidbeta_title1(inputs)
	if (locale === "uk") return uk_forms_androidbeta_title1(inputs)
	if (locale === "ar") return ar_forms_androidbeta_title1(inputs)
	if (locale === "hi") return hi_forms_androidbeta_title1(inputs)
	if (locale === "th") return th_forms_androidbeta_title1(inputs)
	if (locale === "ja") return ja_forms_androidbeta_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_androidbeta_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_androidbeta_title1(inputs)
	return ko_forms_androidbeta_title1(inputs)
});
export { forms_androidbeta_title1 as "forms.androidBeta.title" }